import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Boxes, Server } from "lucide-react";
const tabs = [
    {
        value: "appliance",
        label: "Appliance Software",
        icon: Server
    },
    {
        value: "blast",
        label: "BLAST",
        icon: Boxes
    }
];
export function DistributionTabs({ value, onChange, showApplianceSoftware }) {
    const visibleTabs = showApplianceSoftware ? tabs : tabs.filter((tab)=>tab.value !== "appliance");
    const handleKeyDown = (event, currentIndex)=>{
        let nextIndex;
        if (event.key === "ArrowRight") {
            nextIndex = (currentIndex + 1) % visibleTabs.length;
        } else if (event.key === "ArrowLeft") {
            nextIndex = (currentIndex - 1 + visibleTabs.length) % visibleTabs.length;
        } else if (event.key === "Home") {
            nextIndex = 0;
        } else if (event.key === "End") {
            nextIndex = visibleTabs.length - 1;
        }
        if (nextIndex === undefined) return;
        const nextTab = visibleTabs[nextIndex];
        if (!nextTab) return;
        event.preventDefault();
        onChange(nextTab.value);
        const tabButtons = event.currentTarget.parentElement?.querySelectorAll('[role="tab"]');
        tabButtons?.[nextIndex]?.focus();
    };
    return /*#__PURE__*/ _jsx("div", {
        role: "tablist",
        "aria-label": "Changelog products",
        className: "flex w-full rounded-lg border border-gray-200 bg-white p-1 sm:w-fit",
        children: visibleTabs.map((tab, index)=>{
            const Icon = tab.icon;
            const isSelected = value === tab.value;
            return /*#__PURE__*/ _jsxs("button", {
                type: "button",
                role: "tab",
                id: `changelog-${tab.value}-tab`,
                "aria-controls": "changelog-panel",
                "aria-selected": isSelected,
                tabIndex: isSelected ? 0 : -1,
                onClick: ()=>onChange(tab.value),
                onKeyDown: (event)=>handleKeyDown(event, index),
                className: `inline-flex flex-1 items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy-90 focus-visible:ring-offset-2 sm:flex-none ${isSelected ? "bg-navy-90 text-white" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"}`,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: "h-4 w-4"
                    }),
                    tab.label
                ]
            }, tab.value);
        })
    });
}
